import React, { Suspense, lazy } from 'react';

// Componentes lazy para optimizar la carga inicial
export const LazyAdvancedDashboard = lazy(() => import('./AdvancedDashboard').catch(() => ({ default: () => <div>Error cargando Dashboard</div> })));
export const LazyUserManagement = lazy(() => import('./UserManagement').catch(() => ({ default: () => <div>Error cargando Gestión de Usuarios</div> })));
export const LazySystemSettings = lazy(() => import('./SystemSettings').catch(() => ({ default: () => <div>Error cargando Configuración</div> })));
export const LazyActivityLogs = lazy(() => import('./ActivityLogs').catch(() => ({ default: () => <div>Error cargando Logs</div> })));
export const LazyAdminPanel = lazy(() => import('./AdminPanel').catch(() => ({ default: () => <div>Error cargando Panel</div> })));

// Componente de carga con skeleton
const LoadingSkeleton = ({ componentName }) => (
  <div className="loading-skeleton">
    <div className="skeleton-header">
      <div className="skeleton-title"></div>
      <div className="skeleton-subtitle"></div>
    </div>
    <div className="skeleton-content">
      <div className="skeleton-card"></div>
      <div className="skeleton-card"></div>
      <div className="skeleton-card"></div>
    </div>
    <div className="skeleton-footer">
      <div className="skeleton-button"></div>
      <div className="skeleton-button"></div>
    </div>
  </div>
);

// Wrapper para componentes lazy con fallback personalizado
export const LazyComponent = ({ component: Component, fallback, ...props }) => (
  <Suspense fallback={fallback || <LoadingSkeleton componentName={Component.name} />}>
    <Component {...props} />
  </Suspense>
);

// Hook personalizado para lazy loading con preloading
export const useLazyComponent = (importFn) => {
  const [Component, setComponent] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const loadComponent = React.useCallback(async () => {
    if (Component) return Component;
    
    setIsLoading(true);
    try {
      const module = await importFn();
      setComponent(() => module.default);
    } catch (error) {
      console.error('Error cargando componente lazy:', error);
    } finally {
      setIsLoading(false);
    }
  }, [Component, importFn]);

  // Preload cuando el componente se monta
  React.useEffect(() => {
    loadComponent();
  }, [loadComponent]);

  return { Component, isLoading, loadComponent };
};

// Preloader para componentes críticos
export const Preloader = () => {
  React.useEffect(() => {
    // Preload de componentes administrativos cuando se hace hover en el botón
    const preloadAdminComponents = () => {
      import('./AdvancedDashboard');
      import('./UserManagement');
      import('./SystemSettings');
      import('./ActivityLogs');
    };

    const adminButton = document.querySelector('.nav-btn[onclick*="goToAdmin"]');
    if (adminButton) {
      adminButton.addEventListener('mouseenter', preloadAdminComponents);
      return () => adminButton.removeEventListener('mouseenter', preloadAdminComponents);
    }
  }, []);

  return null;
};

const lazyLoaderDefault = {
  LazyAdvancedDashboard,
  LazyUserManagement,
  LazySystemSettings,
  LazyActivityLogs,
  LazyAdminPanel,
  LazyComponent,
  useLazyComponent,
  Preloader
};
export default lazyLoaderDefault;
